module.exports = __webpack_public_path__ + "static/MXN-463d10bf3c79365ae97ab9466bb33e16.svg";